"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var Amex_1 = __importDefault(require("../Icons/CreditCardIcons/Amex"));
var ApplePay_1 = __importDefault(require("../Icons/CreditCardIcons/ApplePay"));
var DinersClub_1 = __importDefault(require("../Icons/CreditCardIcons/DinersClub"));
var Discover_1 = __importDefault(require("../Icons/CreditCardIcons/Discover"));
var MasterCard_1 = __importDefault(require("../Icons/CreditCardIcons/MasterCard"));
var Unknown_1 = __importDefault(require("../Icons/CreditCardIcons/Unknown"));
var Visa_1 = __importDefault(require("../Icons/CreditCardIcons/Visa"));
var AvailableCards = {
    amex: Amex_1["default"],
    dinersclub: DinersClub_1["default"],
    discover: Discover_1["default"],
    mastercard: MasterCard_1["default"],
    visa: Visa_1["default"],
    applepay: ApplePay_1["default"]
};
var CreditCardImage = function (_a) {
    var cardName = _a.cardName;
    var CardImage = AvailableCards[cardName];
    if (CardImage) {
        return React.createElement(CardImage, { size: design_language_1.Icon.Sizes.Medium });
    }
    return React.createElement(Unknown_1["default"], { size: design_language_1.Icon.Sizes.Medium, color: design_language_1.Colors.SystemBlack });
};
exports["default"] = CreditCardImage;
